import { createSelector } from 'reselect'

import assetsSelector from 'redux/selectors/interactive_video_creation/assets_selector'
import getAssetSelector from 'redux/selectors/assets/asset_selector'
import mediaTypes from 'helpers/enums/mediaTypes'
import metricsVideoSourceTypes from 'helpers/enums/metrics/videoSourceTypes'

const getActivitiesCount = breakpoints => {
	const breakpointActivities = breakpoints.map(breakpoint => breakpoint.activities)
	return breakpointActivities.reduce((activitiesAmount, activities) => activitiesAmount + activities.length, 0)
}

const interactiveVideoData = state => state.interactiveVideoCreation

const metricsVideoSavedDataSelector = createSelector(
	[ interactiveVideoData, assetsSelector, getAssetSelector ],
	(interactiveVideo, assetById, getAsset) => {
		const assetUid = assetById.videoUid
		const asset = getAsset(assetUid, mediaTypes.VIDEO)

		return {
			totalActivities: getActivitiesCount(interactiveVideo.media.breakpoints),
			source: asset ? metricsVideoSourceTypes[asset.versions[0].source] : '',
		}
	}
)

export default metricsVideoSavedDataSelector
